<template>
  <Card variant="outline" size="medium">
    <template #header>
      <Text variant="h4">Personal Details</Text>

      <slot name="actions" />
    </template>

    <div class="details" v-if="personalDetails">
      <View class="about-you" gap="sm" direction="column">
        <Text variant="label-medium" color="tertiary">About you</Text>
        <Text variant="body-medium">{{ personalDetails?.aboutYou || '&dash;' }}</Text>
      </View>

      <Text variant="label-medium" color="tertiary">Smoker</Text>
      <Text variant="body-medium">{{ personalDetails?.isSmoker ? 'Yes' : 'No' }}</Text>

      <Text variant="label-medium" color="tertiary">Desired move-in date</Text>
      <Text variant="body-medium" :title="props.personalDetails?.desiredMoveInDate">
        {{ desiredMoveInDate }}
      </Text>
    </div>

    <Text v-else variant="body-medium">No info</Text>
  </Card>
</template>

<script setup lang="ts">
import { useDateFormat } from '@vueuse/core';
import { computed } from 'vue';

import { Card, Text, View } from '@tallo/design-system';

import { ApplicationRenterDetailsDto } from '../../interfaces/renter-details.interface';

const props = defineProps<{ personalDetails?: ApplicationRenterDetailsDto | null }>();
const desiredMoveInDate = computed(() => {
  const result = [];
  const desiredMoveInDate = props.personalDetails?.desiredMoveInDate;
  const isMoveInDateFlexible = props.personalDetails?.isMoveInDateFlexible;

  if (desiredMoveInDate) {
    result.push(useDateFormat(desiredMoveInDate, 'MMM, DD').value);
  }

  if (isMoveInDateFlexible) {
    result.push(desiredMoveInDate ? '(Flexible)' : 'Flexible');
  }

  return result.join(' ') || '-';
});
</script>

<style scoped lang="scss">
.details {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--t-spacing-md);

  .about-you {
    grid-column: 1 / span 2;
  }
}
</style>
